<template>
  <div class="project-overview project-wampper bg071129">
    <div class="content-left overview-left"  @mouseenter="tabEnd()"  @mouseleave="tabStart()">
      <div class="content-introduced c-b-1" :class="{activebg:activeNum==0}" @click="activeNum=0">
        <div class="left-child">
          <span class="top-bg-icon" :class="activeNum==0? 'l1a' : 'l1'"></span>
          <h4>工程概况</h4>
          <h5 class="font-size-18" v-html="projectData.info"></h5>
          <div class="item-child">
            <p>
              平均气温/°C
              <span>{{projectData.engineerValue[0]}}</span>
            </p>
            <p>
              平均降水/mm
              <span>{{projectData.engineerValue[1]}}</span>
            </p>
          </div>
          <div class="item-child">
            <p>
              平均风速/m
              <span>{{projectData.engineerValue[2]}}</span>
            </p>
            <p>
              标准冻土深度/m
              <span>{{projectData.engineerValue[3]}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="content-introduced c-b-2" :class="{activebg:activeNum==1}" @click="activeNum=1">
        <div class="left-child">
          <span class="top-bg-icon l2" :class="activeNum==1? 'l2a' : 'l2'"></span>
          <h4>设计概况</h4>
          <div class="item-child" v-for="(item, index) in projectData.design" :key="index" :class="index===0?'item2':''">
            <p v-for="(ele, ind) in item" :key="ind">
              {{ele.label}}
              <span>{{ele.value}}</span>
            </p>
          </div>
          <!-- <div class="item-child item2">
            <p>
              用地面积/㎡
              <span>174545.46</span>
            </p>
            <p>
              总建筑面积/㎡
              <span>36964.77</span>
            </p>
          </div>
          <div class="item-child">
            <p>
              <i>1#</i>公共货代库/㎡
              <span>7821.07</span>
            </p>
            <p>
              <i>2#</i>公共货代库/㎡
              <span>8106.08</span>
            </p>
          </div>
          <div class="item-child">
            <p>
              <i>3#</i>冷链生鲜库/㎡
              <span>10271.31</span>
            </p>
            <p>
              <i>4#</i>快件收发中心/㎡
              <span>10271.31</span>
            </p>
          </div> -->
        </div>
      </div>
      <div class="content-introduced c-b-3" :class="{activebg:activeNum==2}" @click="activeNum=2">
        <div class="left-child">
          <span class="top-bg-icon l3" :class="activeNum==2? 'l3a' : 'l3'"></span>
          <h4>施工阶段进度计划</h4>
          <div class="last-child">
            总计划工期：
            <p>{{projectData.day}}日历天</p>
          </div> 
        </div>
      </div>
    </div>
    <div class="content-right">
      <template v-for="(pic, index) in projectData.pics">
        <div :key="index" class="right-banner" v-show="activeNum==index">
          <img :src="require(`../../assets/images/overview/${pic}`)" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProjectOverview",
  components: {},
  data() {
    return {
      activeNum: 0,
    };
  },
  props: {
    
	},
  computed: {
    projectData() {
      return this.$project.projectData.overview;
    }
  },
  mounted() {
    this.tabStart()
  },
  methods: {
    tabStart(){
      let _this = this;
      _this.timer = setInterval(function() {
        if(_this.activeNum >= 2){
          _this.activeNum  = 0;
        }else{
          _this.activeNum += 1;
        }
      }, 60000);
    },
    tabEnd(){
      clearInterval(this.timer);
    }
  },
  watch: {},
  beforeDestroy: function() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};
</script>

<style lang="scss" scoped> 
.project-wampper{
  overflow-x: auto;

}
.overview-left{
  display: flex;
  flex-direction: column ; 
  font-family: SourceHanSansCN;
  .activebg{
    background:rgba(33, 127, 211, 0.8) !important;
  }
  .c-b-3{
    margin: 0 !important;
  }
  .content-introduced{
    cursor: pointer;
    min-height: 326px;
    flex:1;
    background: #293549;
    align-items:center;
    margin-bottom: 10px;
    color: rgba(255,255,255,.8);
    .left-child{
      margin: 21px 0 10px 32px;
      position: relative;
      .top-bg-icon{
        position: absolute;
        top: -24px;
        right: 0;
        z-index: 2;
        width: 155px;
        height: 191px;
      }
      .l1{
        background: url("../../assets/images/overview/l1.png") no-repeat;
        background-size: cover;
      }
      .l2{
        background: url("../../assets/images/overview/l2.png") no-repeat;
        background-size: cover;
      }
      .l3{
        background: url("../../assets/images/overview/l3.png") no-repeat;
        background-size: cover;
      }
      .l1a{ 
        background: url("../../assets/images/overview/l1-a.png") no-repeat;
        background-size: cover;
      }
      .l2a{ 
        background: url("../../assets/images/overview/l2-a.png") no-repeat;
        background-size: cover;
      }
      .l3a{ 
        background: url("../../assets/images/overview/l3-a.png") no-repeat;
        background-size: cover;
  }
      h4{
        font-size: 24px;
        font-weight: bold;
      }
      h5{
        margin: 18px 0 24px;
      }
      .item2{
        margin: 14px 0 4px;
      }
      h5,.item-child{
        display: flex;
        p{
          flex: 1;
          margin-bottom: 20px;
          font-size: 16px;
          font-family: SourceHanSansCN;
          font-weight: 550;
          span{
            font-size: 24px;
            font-family: AlibabaPuHuiTi;
            display: block;
            margin-top: 10px;
          }
        }
      }
      .last-child{
        margin-top: 45px;
        font-size: 16px;
        font-family: SourceHanSansCN;
        font-weight: 550;
        p{
          font-size: 48px;
          font-family: AlibabaPuHuiTi;
          display: block;
          margin-top: 10px;

        }
      }
    }
  } 
}

.content-right{
  height: 100%; 
  min-height: 1000px;
  overflow-x: auto !important;
  .right-banner{
    height: 100%;  
    width: 100%;
    overflow-y: auto !important;
    img {
      width: 100%;
    }
  }
  .banner0{ 
    background: url("../../assets/images/overview/ob1.png") no-repeat;
    background-size: 100%;
  }
  .banner1{ 
    background: url("../../assets/images/overview/ob2.png") no-repeat;
    background-size: 100%;
  }
  .banner2{ 
    background: url("../../assets/images/overview/ob3.png") no-repeat;
    background-size: 100%;
  }
  
} 
</style>